document.addEventListener('DOMContentLoaded', () => {

  // --- CONFIGURATION & SETUP ---
  const MOBILE_BREAKPOINT = 750;

  // Exit if on desktop or if navigator already exists
  if (window.innerWidth >= MOBILE_BREAKPOINT || document.querySelector('.yip-brands-nav-container')) {
    return;
  }

  const allDividerElements = document.querySelectorAll('h2[data-letter]');
  if (allDividerElements.length === 0) return;

  const dividers = Array.from(allDividerElements).map(el => {
    el.style.scrollMarginTop = '80px';
    return {
      element: el,
      letter: el.dataset.letter.toUpperCase(),
    };
  });

  // --- DOM CREATION ---
  const navContainer = document.createElement('div');
  navContainer.className = 'yip-brands-nav-container';

  const nav = document.createElement('nav');
  nav.className = 'yip-brands-nav';

  const letterIndicator = document.createElement('div');
  letterIndicator.className = 'yip-letter-indicator';
  letterIndicator.style.display = 'none';
  letterIndicator.style.transition = 'opacity 0.1s ease-out, transform 0.1s ease-out';

  const turkishAlphabet = ['A', 'B', 'C', 'Ç', 'D', 'E', 'F', 'G', 'Ğ', 'H', 'I', 'İ', 'J', 'K', 'L', 'M', 'N', 'O', 'Ö', 'P', 'Q', 'R', 'S', 'Ş', 'T', 'U', 'Ü', 'V', 'W', 'X', 'Y', 'Z'];
  
  const availableLetters = [...new Set(dividers.map(d => d.letter))];
  const sortedLetters = turkishAlphabet.filter(letter => availableLetters.includes(letter));
  
  const buttonMap = new Map();

  sortedLetters.forEach(letter => {
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.letter = letter;
    button.setAttribute('aria-label', `${letter} harfi ile başlayan markalar`);
    nav.appendChild(button);
    buttonMap.set(letter, button);
  });

  navContainer.appendChild(nav);
  
  document.body.appendChild(navContainer);
  document.body.appendChild(letterIndicator);

  // --- INTERACTION LOGIC ---
  let isObserverActive = true;

  const sectionObserver = new IntersectionObserver((entries) => {
    if (!isObserverActive) return;
    
    let topEntry = null;
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (!topEntry || entry.boundingClientRect.top < topEntry.boundingClientRect.top) {
          topEntry = entry;
        }
      }
    });

    if (topEntry) {
      const activeLetter = topEntry.target.dataset.letter.toUpperCase();
      updateActiveButton(activeLetter);
    }
  }, { rootMargin: '-10% 0px -70% 0px' });

  dividers.forEach(d => sectionObserver.observe(d.element));

  // --- HELPER FUNCTIONS ---
  function updateActiveButton(activeLetter) {
    buttonMap.forEach((btn, letter) => {
      const isActive = letter === activeLetter;
      btn.classList.toggle('active', isActive);
      btn.textContent = isActive ? letter : '';
    });
  }
  
  function showLetterIndicator(letter, buttonCenterY) {
    letterIndicator.textContent = letter;
    letterIndicator.style.display = 'flex';
    letterIndicator.style.opacity = '1';

    letterIndicator.style.top = `${buttonCenterY}px`;
  }

  function hideLetterIndicator() {
    letterIndicator.style.opacity = '0';
    setTimeout(() => {
      letterIndicator.style.display = 'none';
    }, 100);
  }

  // --- EVENT HANDLERS ---
  let currentTouchLetter = null;
  let isDragging = false;
  
  const handleTouchInteraction = (clientY) => {
    let closestButton = null;
    let minDistance = Infinity;

    // Find the button closest to the touch position
    buttonMap.forEach(button => {
      const rect = button.getBoundingClientRect();
      const buttonCenterY = rect.top + rect.height / 2;
      const distance = Math.abs(clientY - buttonCenterY);

      if (distance < minDistance) {
        minDistance = distance;
        closestButton = button;
      }
    });

    if (!closestButton) return;

    const letter = closestButton.dataset.letter;

    if (letter !== currentTouchLetter) {
      currentTouchLetter = letter;
      
      updateActiveButton(letter);
      
      const targetDivider = dividers.find(d => d.letter === letter);
      if (targetDivider) {
        targetDivider.element.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
    }

    const finalRect = closestButton.getBoundingClientRect();
    const finalButtonCenterY = finalRect.top + finalRect.height / 2;
    
    showLetterIndicator(letter, finalButtonCenterY);
  };

  navContainer.addEventListener('touchstart', e => {
    e.preventDefault();
    isDragging = true;
    isObserverActive = false;
    handleTouchInteraction(e.touches[0].clientY);
  }, { passive: false });

  navContainer.addEventListener('touchmove', e => {
    e.preventDefault();
    if (!isDragging) return;
    handleTouchInteraction(e.touches[0].clientY);
  }, { passive: false });

  document.addEventListener('touchend', () => {
    if (!isDragging) return;
    
    isDragging = false;
    hideLetterIndicator();
    
    currentTouchLetter = null;

    setTimeout(() => { isObserverActive = true; }, 300);
  });

  // Click handler
  nav.addEventListener('click', e => {
    const button = e.target.closest('button');
    if (!button) return;
    
    isObserverActive = false;
    
    const targetLetter = button.dataset.letter;
    updateActiveButton(targetLetter);
    
    const targetDivider = dividers.find(d => d.letter === targetLetter);
    if (targetDivider) {
      targetDivider.element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    
    setTimeout(() => { isObserverActive = true; }, 800);
  });

  // Visibility Observer
  const mainContent = document.getElementById('MainContent');
  if (mainContent) {
    const visibilityObserver = new IntersectionObserver(([entry]) => {
      navContainer.classList.toggle('is-visible', entry.isIntersecting);
    }, { rootMargin: "0px 0px -15% 0px" });
    visibilityObserver.observe(mainContent);
  }

  // Set initial active state
  if (sortedLetters.length > 0) {
    updateActiveButton(sortedLetters[0]);
  }

  // Handle window resize
  window.addEventListener('resize', () => {
    if (window.innerWidth >= MOBILE_BREAKPOINT && navContainer.parentElement) {
      sectionObserver.disconnect();
      navContainer.remove();
    }
  });
});